
import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AlertPopover from '@/components/alerts/AlertPopover';
import LogoutButton from './LogoutButton';
import MessagesNotification from './MessagesNotification';

interface MobileHeaderProps {
  onToggleSidebar: () => void;
  alerts: any[];
  onNavigate: () => void;
  onMarkAsRead: (alertId: string) => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onToggleSidebar,
  alerts,
  onNavigate,
  onMarkAsRead
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b shadow-sm">
      <div className="flex items-center justify-between w-full h-14 sm:h-16 px-3 sm:px-4">
        <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-9 w-9 sm:h-10 sm:w-10 p-0 hover:bg-accent flex items-center justify-center flex-shrink-0"
            onClick={onToggleSidebar}
            aria-label="Toggle menu"
          >
            <Menu className="h-5 w-5 sm:h-6 sm:w-6" />
          </Button>
          <Link to="/dashboard" className="flex items-center min-w-0">
            <img 
              src="/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png" 
              alt="ProptPilot Logo" 
              className="h-6 sm:h-8 w-auto max-w-[100px] sm:max-w-[120px]"
              style={{ objectFit: 'contain' }}
            />
          </Link>
        </div>
        
        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
          <MessagesNotification />
          <AlertPopover 
            alerts={alerts} 
            onNavigate={onNavigate}
            onMarkAsRead={onMarkAsRead}
          />
          <LogoutButton variant="mobile" />
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
